import React from "react";

function AssignIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 2.75L21.25 9.75L14.25 16.75V12.1762C8.7311 12.1762 4.12018 16.0639 3.00641 21.25C2.83843 20.4678 2.75 19.6561 2.75 18.8238C2.75 12.4725 7.89873 7.32374 14.25 7.32374V2.75Z"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default AssignIcon;
